import { styled } from 'styled-components';
import { Button } from '../../Button';
import { getFontWeight } from '../../../abstracts/typography';
export const AlertBannerTextButton = styled(Button).withConfig({
  displayName: "AlertBannerTextButton",
  componentId: "asurion-ui-react__sc-1fe62iu-0"
})(["color:currentColor;font-weight:", ";line-height:1.5;white-space:break-spaces;&:not(:disabled):hover,&:not(:disabled):active{color:currentColor;}"], getFontWeight('heavy'));